const {STORAGE_KEY, REMINDER_KEY, nextReminder, parseWishlist, toggleWishlist} = await import(document.querySelector('script[data-vr-area-script]').dataset.storeUrl);

const root = window.Shopify?.routes?.root || '/';
const areaUrl = `${root}pages/area-personale`;
const area = document.querySelector('[data-vr-area]');
// Used only for presentation. Account access is still verified by Shopify.
const signedIn = document.querySelector('script[data-vr-area-script]').dataset.customerSignedIn === 'true';
const callback=new URL(location.href);
if(area && signedIn && callback.searchParams.get('complete_profile')==='1') {
  const requestedName=callback.searchParams.get('first_name') || '';
  callback.searchParams.delete('complete_profile');callback.searchParams.delete('first_name');
  history.replaceState(null,'',callback.pathname+callback.search+callback.hash);
  if(document.querySelector('script[data-vr-area-script]').dataset.nameRequired==='true') {
    const destination=new URL('https://shopify.com/57083527318/account/pages/01a10898-adf2-74bb-a7e3-85ccd12964ae');
    destination.searchParams.set('onboarding','1');destination.searchParams.set('first_name',requestedName);
    location.replace(destination.href);
  }
}
const productCache = new Map();
let renderSequence = 0;
let cartSequence = 0;
let toastTimer;
let reminderMemory=null;
function shouldShowReminder() {
  let previous=reminderMemory;
  try { previous=JSON.parse(localStorage.getItem(REMINDER_KEY)) ?? previous; } catch { /* Keep an in-memory fallback if storage is unavailable. */ }
  const result=nextReminder(previous,Date.now());
  reminderMemory=result.state;
  try { localStorage.setItem(REMINDER_KEY,JSON.stringify(result.state)); } catch { /* Reminder failure must never affect a saved favourite. */ }
  return result.show;
}
function el(tag, text, className) {
  const node = document.createElement(tag);
  if (text !== undefined) node.textContent = text;
  if (className) node.className = className;
  return node;
}
function read() { return parseWishlist(localStorage.getItem(STORAGE_KEY)); }
function write(items) {
  // Never claim success when browser storage is unavailable/full.
  localStorage.setItem(STORAGE_KEY, JSON.stringify({version:1,items}));
  syncHearts(items);
}
function noticeIcon(kind) {
  const icons={"heart":{"viewBox":"0 0 24 24","elements":[{"tag":"path","attrs":{"d":"M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"}}]},"cart":{"viewBox":"0 0 24 24","elements":[{"tag":"path","attrs":{"d":"M2 2h3l1 3h16l-3 11H8L5 5H2zm7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4m9 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4"}}]},"account":{"viewBox":"0 0 512 512","elements":[{"tag":"circle","attrs":{"cx":"256","cy":"160","r":"96","fill":"currentColor"}},{"tag":"path","attrs":{"d":"M80 432v-16c0-80 65-144 144-144h64c79 0 144 64 144 144v16a16 16 0 0 1-16 16H96a16 16 0 0 1-16-16Z","fill":"currentColor"}}]}};
  const source=icons[kind],svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('viewBox',source.viewBox);svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');
  for(const item of source.elements){const part=document.createElementNS(svg.namespaceURI,item.tag);for(const [key,value] of Object.entries(item.attrs))part.setAttribute(key,value);svg.append(part);}return svg;
}
function toast(message,kind) {
  document.querySelector('.vr-area-toast')?.remove();clearTimeout(toastTimer);
  const box=el('div',undefined,'vr-area-toast'+(kind?' vr-added-notice':''));box.setAttribute('role','status');box.setAttribute('aria-live','polite');
  if(kind){
    const cart=kind==='cart',top=el('div',undefined,'vr-added-notice-top'),icon=el('span',undefined,'vr-added-notice-icon '+(cart?'is-cart':'is-heart'));
    icon.append(noticeIcon(cart?'cart':'heart'));top.append(icon,el('span',cart?'Aggiunto al\nCarrello':'Aggiunto alla\ntua Wishlist','vr-added-notice-title'));
    const link=el('a',undefined,'vr-added-notice-link');link.href=areaUrl+(cart?'#carrello':'#preferiti');
    const copy=el('span',undefined,'vr-added-notice-copy');copy.append(document.createTextNode('ACCEDI ALL’'),el('span','AREA RISERVATA','vr-added-notice-area'),document.createTextNode(cart?'\nPER VEDERE IL TUO CARRELLO':'\nPER VEDERE I TUOI PREFERITI'));link.append(copy,noticeIcon('account'));
    link.addEventListener('click',event=>{
      if(!window.VRAccountAccess)return;
      event.preventDefault();void window.VRAccountAccess.require({intent:'area',returnTo:link.href,trigger:link}).then(ok=>{if(ok)location.assign(link.href);});
    });

    box.append(top,link);
  }else{
    box.append(el('span',message));const link=el('a','Apri wishlist');link.href=areaUrl+'#preferiti';box.append(link);
  }
  const close=el('button','×',kind?'vr-added-notice-close':undefined);close.type='button';close.setAttribute('aria-label','Chiudi messaggio');close.addEventListener('click',()=>box.remove());box.append(close);document.body.append(box);
  toastTimer=setTimeout(()=>box.remove(),8000);
}
window.VRAddedNotice={show:kind=>toast('',kind)};
window.addEventListener('vr:cart-added',()=>{
  const access=window.VRAccountAccess;
  if(access&&!access.isSignedIn())void access.open({intent:'browse'}).then(()=>toast('', 'cart'));
  else toast('', 'cart');
});
function savedDialog(trigger) {
  if(window.VRAccountAccess)void window.VRAccountAccess.open({intent:'browse',trigger,ignoreDismiss:true}).then(()=>toast('', 'wishlist'));else toast('', 'wishlist');
}
function syncHeaderAccountState(items) {
  document.querySelectorAll('.vr-header-lists-account').forEach(link=>{
    const owner=document.querySelector('script[data-vr-area-script]')?.dataset.customerKey||'guest';
    let hasOffers=false;
    try{hasOffers=JSON.parse(localStorage.getItem('vr_offer_receipts_v1')||'[]').some(receipt=>receipt.owner===owner);}catch{}
    const hasContent=items.length>0||Number(link.dataset.vrCartItems)>0||Number(link.dataset.vrOrderCount)>0||hasOffers;
    link.classList.toggle('is-filled',signedIn&&hasContent);
  });
}
function syncHearts(items) {
  syncHeaderAccountState(items);
  document.querySelectorAll('[data-vr-wish-product]').forEach(heart=>{
    const saved = items.some(item=>item.id === heart.dataset.vrWishProduct);
    heart.setAttribute('role','button'); heart.setAttribute('aria-pressed',String(saved));
    heart.setAttribute('aria-label',`${saved ? 'Rimuovi dai' : 'Salva nei'} preferiti: ${heart.dataset.vrWishTitle || 'arredo'}`);
    heart.title = saved ? 'Rimuovi dai preferiti' : 'Salva nei preferiti';
    const label = heart.querySelector('span'); if(label) label.textContent = saved ? 'Salvato nei preferiti' : 'Salva nei preferiti';
  });
  document.querySelectorAll('[data-vr-wish-count]').forEach(node=>node.textContent = items.length);
}
window.addEventListener('pageshow',()=>initializeHearts());
window.addEventListener('focus',()=>initializeHearts());
document.addEventListener('visibilitychange',()=>{if(!document.hidden)initializeHearts();});
function initializeHearts() { try { syncHearts(read()); } catch { /* A click will explain storage errors. */ } }
document.addEventListener('click', event=>{
  const heart = event.target.closest('[data-vr-wish-product]');
  if(!heart || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault(); event.stopImmediatePropagation();
  try {
    const items = toggleWishlist(read(), {id:heart.dataset.vrWishProduct,handle:heart.dataset.vrWishHandle});
    write(items);
    if(items.some(item=>item.id===heart.dataset.vrWishProduct)) {
      if(!signedIn) savedDialog(heart);
      else toast('', 'wishlist');
    }
    else toast('Arredo rimosso dai preferiti.');
    if(area) void renderWishlist();
  } catch(error) { toast(error.message || 'Il browser non permette di salvare i preferiti.'); }
}, true);
document.addEventListener('keydown',event=>{
  if(event.code === 'Space' && event.target.matches('[data-vr-wish-product]')) { event.preventDefault(); event.target.click(); }
});
document.addEventListener('shopify:section:load', initializeHearts);
const heartObserver = new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1 && (node.matches?.('[data-vr-wish-product]') || node.querySelector?.('[data-vr-wish-product]'))))) initializeHearts();});
heartObserver.observe(document.body,{childList:true,subtree:true});
window.addEventListener('storage',event=>{if(event.key===STORAGE_KEY || event.key===null) { initializeHearts(); if(area) void renderWishlist(); }});
initializeHearts();

async function jsonRequest(path, options = {}) {
  const response = await fetch(path, {credentials:'same-origin',...options});
  const data = await response.json();
  if(!response.ok) throw new Error(typeof data.description==='string' ? data.description : 'Richiesta non completata. Riprova.');
  if(options.method&&options.method.toUpperCase()!=='GET'&&/cart\/(add|change|update|clear)\.js/.test(path)){
    window.dispatchEvent(new Event('vr:cart-changed'));
    try{localStorage.setItem('vr_cart_changed_v1',String(Date.now()));}catch{}
  }
  return data;
}
async function productDetails(item) {
  if(!productCache.has(item.handle)) {
    productCache.set(item.handle, jsonRequest(`${root}products/${encodeURIComponent(item.handle)}.js`).then(product=>{
      if(String(product.id)!==item.id) throw new Error('Prodotto non più disponibile.');
      return product;
    }).catch(error=>{productCache.delete(item.handle);throw error;}));
  }
  return productCache.get(item.handle);
}
function money(value) { return new Intl.NumberFormat(document.documentElement.lang || 'it-IT',{style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(value/100); }
function productRow(product, {image,href,price}={}) {
  const row = el('article',undefined,'vr-area-item');
  const imageLink = el('a',undefined,'vr-area-image'); imageLink.href = href;
  if(image) { const img=el('img'); img.src=image; img.alt=product.title; img.loading='lazy'; imageLink.append(img); }
  const details = el('div',undefined,'vr-area-details');
  const heading=el('h2'),link=el('a',product.title);link.href=href;heading.append(link);details.append(heading,el('p',money(price),'vr-area-price'));
  const actions=el('div',undefined,'vr-area-actions');
  row.append(imageLink,details,actions);
  return {row,details,actions};
}
const receiptKey='vr_offer_receipts_v1';
const cartDateKey='vr_cart_added_v1';
const ownerKey=()=>document.querySelector('script[data-vr-area-script]')?.dataset.customerKey || 'guest';
function offerReceipts(){try{return JSON.parse(localStorage.getItem(receiptKey)||'[]').filter(r=>r.owner===ownerKey()).slice(-30);}catch{return [];}}
function addedDates(){try{return JSON.parse(localStorage.getItem(cartDateKey)||'{}');}catch{return {};}}
function recordCartDate(variant){try{const dates=addedDates();if(!dates[variant])dates[variant]=Date.now();localStorage.setItem(cartDateKey,JSON.stringify(dates));}catch{}}
function reconcileCartDates(cart){try{const dates=addedDates(),ids=new Set(cart.items.map(i=>String(i.variant_id)));for(const id of Object.keys(dates)){if(!ids.has(id))delete dates[id];}localStorage.setItem(cartDateKey,JSON.stringify(dates));}catch{}}
let offerSnapshot=[],offerRefreshAt=0,offerRefreshPromise=null,accountOffersUnavailable=false;
async function refreshOffers(){
  if(offerRefreshPromise)return offerRefreshPromise;
  if(Date.now()-offerRefreshAt<15000)return;
  offerRefreshAt=Date.now();
  offerRefreshPromise=(async()=>{
    const receipts=offerReceipts();let local=[],account=[];
    const requests=[];
    if(receipts.length)requests.push((async()=>{try{
      const response=await fetch('https://veroraro-ai-poc.matteo-salce.workers.dev/offers/customer-status',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'omit',cache:'no-store',body:JSON.stringify({receipts:receipts.map(r=>({reference:r.reference,token:r.token}))})});
      if(!response.ok)throw Error('status');const data=await response.json();if(!Array.isArray(data.offers))throw Error('status');
      local=receipts.map(r=>data.offers.find(o=>o.reference===r.reference)||{...r,state:'checking'});
    }catch{local=receipts.map(r=>({...r,state:'checking'}));}})());
    if(signedIn)requests.push((async()=>{try{
      const response=await fetch(root+'apps/veroraro-account/offers',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw Error('account');const data=await response.json();if(data.accountLinked!==true||!Array.isArray(data.offers))throw Error('account');
      account=data.offers;accountOffersUnavailable=false;
    }catch{accountOffersUnavailable=true;}})());
    await Promise.all(requests);
    offerSnapshot=[...new Map([...local,...account].map(o=>[o.reference,o])).values()];
  })();
  try{await offerRefreshPromise;}finally{offerRefreshPromise=null;}
}
function knownPurchase(product,variant){
  try{return JSON.parse(area.querySelector('[data-vr-purchases]')?.textContent||'[]').some(p=>String(p.product)===String(product.id)&&(!variant||String(p.variant)===String(variant.id)));}catch{return false;}
}
function offerFor(product,variant){
  const ids=variant?[String(variant.id)]:(product.variants||[]).map(v=>String(v.id));
  return offerSnapshot.filter(o=>ids.includes(String(o.variant))).sort((a,b)=>(b.createdAt||0)-(a.createdAt||0))[0];
}
function cartIndicator(date){
  const control=el('button',undefined,'vr-area-button vr-area-add vr-area-in-cart');control.type='button';control.disabled=true;
  const validDate=Number.isFinite(date)&&date>0&&date<=Date.now();
  control.append(el('span','Aggiunto al\ncarrello'+(validDate?' il\n'+new Intl.DateTimeFormat('it-IT',{dateStyle:'short'}).format(date):'')));
  const icon=el('img');icon.alt='';icon.setAttribute('aria-hidden','true');
  icon.src='data:image/svg+xml,'+encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#999999"><path d="M2 2h3l1 3h16l-3 11H8L5 5H2zm7 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4m9 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4"/></svg>');control.append(icon);return control;
}
function appendProductControls({product,variant,href,details,actions,status,inCart=false,inCartVariant=null}){
  const offer=offerFor(product,variant),purchased=knownPurchase(product,variant)||offer?.state==='purchased';
  const agreed=offer&&['accepted','counter','checking'].includes(offer.state);
  const buy=el('button',purchased?'GIÀ ACQUISTATO':'ACQUISTA ORA','vr-area-button vr-area-button-primary vr-area-buy');buy.type='button';
  if(purchased){buy.disabled=true;buy.classList.add('vr-area-unavailable');}
  else if(!variant?.available){buy.textContent='NON DISPONIBILE';buy.disabled=true;buy.classList.add('vr-area-unavailable');}
  else if(agreed){buy.disabled=true;buy.textContent='ACQUISTO TRAMITE OFFERTA';}
  else buy.addEventListener('click',async()=>{
    const access=window.VRAccountAccess;if(!access||!await access.require({intent:'purchase',purchase:{variant:String(variant.id),quantity:1},trigger:buy}))return;
    buy.disabled=true;buy.textContent='APERTURA CHECKOUT…';
    try{
      // Never add a second copy of an item already in the current cart.
      const cart=await jsonRequest(`${root}cart.js`);
      if(!cart.items.some(i=>String(i.variant_id)===String(variant.id))){await jsonRequest(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});recordCartDate(variant.id);}
      location.assign(`${root}checkout`);
    }catch(error){status.textContent=error.message;buy.textContent='ACQUISTA ORA';buy.disabled=false;}
  });
  actions.append(buy);
  if(inCart){actions.append(cartIndicator(addedDates()[inCartVariant||variant?.id]));}
  else if(variant?.available&&!purchased&&!agreed){
    const add=cartIndicator();add.disabled=false;add.classList.remove('vr-area-in-cart');add.querySelector('span').textContent='Aggiungi\nal carrello';
    add.querySelector('img').src=add.querySelector('img').src.replace('%23999999','%23899b83');
    add.addEventListener('click',async()=>{
      add.disabled=true;
      try{
        const cart=await jsonRequest(`${root}cart.js`);
        if(!cart.items.some(i=>String(i.variant_id)===String(variant.id))){await jsonRequest(`${root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})});recordCartDate(variant.id);}
        status.textContent='Arredo aggiunto al carrello.';await renderWishlist();window.dispatchEvent(new Event('vr:cart-added'));
      }catch(error){status.textContent=error.message;add.disabled=false;}
    });actions.append(add);
  }
  const shipping=el('a','CALCOLA SPEDIZIONE','vr-area-button vr-area-shipping');shipping.href=href+'#calcola-spedizione';details.append(shipping);
  const group=el('div',undefined,'vr-area-offer-group');
  const labels={pending:'OFFERTA IN ATTESA',accepted:'OFFERTA ACCETTATA',counter:'ACCETTA OFFERTA',expired:'OFFERTA SCADUTA',checking:'STATO OFFERTA DA VERIFICARE',unavailable:'STATO OFFERTA DA VERIFICARE',purchased:'GIÀ ACQUISTATO'};
  const canPurchase=offer&&['counter','accepted'].includes(offer.state)&&typeof offer.purchaseUrl==='string'&&/^https:\/\/veroraro-ai-poc\.matteo-salce\.workers\.dev\/offer-purchase\/[a-f0-9]{64}$/.test(offer.purchaseUrl);
  const link=el(!offer&&!purchased||canPurchase&&offer.state==='counter'?'a':'button',purchased?'GIÀ ACQUISTATO':labels[offer?.state]||'FAI UN’OFFERTA','vr-area-button vr-area-offer');
  if(link.tagName==='A')link.href=canPurchase?offer.purchaseUrl:href+'#fai-offerta';
  else{link.type='button';link.disabled=true;}
  if(offer?.state)link.dataset.vrOfferState=purchased?'purchased':offer.state;
  group.append(link);
  if(canPurchase&&offer.state==='accepted'&&!purchased){const checkout=el('a','Vai all’acquisto','vr-area-offer-checkout');checkout.href=offer.purchaseUrl;group.append(checkout);}
  actions.append(group);
}

async function renderWishlist() {
  const list=area.querySelector('[data-vr-wish-list]'),status=area.querySelector('[data-vr-wish-status]');
  const sequence=++renderSequence;
  let items;
  try { items=read(); syncHearts(items); } catch(error) { status.textContent=error.message;return; }
  list.replaceChildren();
  if(!items.length) {
    status.textContent='';
    const empty=el('div',undefined,'vr-area-empty'); empty.append(el('h2','I tuoi arredi preferiti, tutti qui.'),el('p','Tocca il cuore di un arredo per salvarlo senza registrazione.'));
    const link=el('a','SCOPRI GLI ARREDI','vr-area-button');link.href=`${root}collections/disponibili`;empty.append(link);list.append(empty);return;
  }
  status.textContent='Caricamento dei tuoi preferiti…';
  const [results,cartResult]=await Promise.all([Promise.allSettled(items.map(productDetails)),jsonRequest(`${root}cart.js`).catch(()=>null),refreshOffers()]);if(cartResult)reconcileCartDates(cartResult);
  if(sequence!==renderSequence)return;
  status.textContent='';
  results.forEach((result,index)=>{
    const item=items[index];
    let row,details,actions;
    if(result.status==='fulfilled') {
      const product=result.value,href=`${root}products/${encodeURIComponent(item.handle)}`;
      const variant=product.variants.find(variant=>variant.available);
      ({row,details,actions}=productRow(product,{image:product.featured_image,href,price:variant?.price ?? product.price}));
      const cartItem=cartResult?.items.find(i=>String(i.product_id)===String(product.id));
      const selected=cartItem?product.variants.find(v=>String(v.id)===String(cartItem.variant_id)):variant;
      if(!cartItem&&product.variants.filter(v=>v.available).length>1){
        const choose=el('a','SCEGLI LE OPZIONI','vr-area-button vr-area-button-primary');choose.href=href;actions.append(choose);
        const shipping=el('a','CALCOLA SPEDIZIONE','vr-area-button vr-area-shipping');shipping.href=href+'#calcola-spedizione';details.append(shipping);
        const offer=el('a','FAI UN’OFFERTA','vr-area-button vr-area-offer');offer.href=href+'#fai-offerta';actions.append(offer);
      }else if(cartResult){appendProductControls({product,variant:selected,href,details,actions,status,inCart:!!cartItem,inCartVariant:cartItem?.variant_id});}
      else{const retry=el('a','APRI IL PRODOTTO','vr-area-button vr-area-button-primary');retry.href=href;actions.append(retry);}

    } else {
      row=el('article',undefined,'vr-area-item');details=el('div',undefined,'vr-area-details');actions=el('div',undefined,'vr-area-actions');
      details.append(el('h2','Arredo momentaneamente non disponibile'),el('p','Il preferito è conservato. Puoi riprovare più tardi.'));row.append(details,actions);
    }
    const remove=el('button','Rimuovi dai preferiti','vr-area-remove');remove.type='button';
    remove.addEventListener('click',()=>{try{write(read().filter(entry=>entry.id!==item.id));void renderWishlist();}catch(error){status.textContent=error.message;}});
    details.append(remove);list.append(row);
  });
}
async function renderCart() {
  const sequence=++cartSequence;
  const list=area.querySelector('[data-vr-cart-list]'),status=area.querySelector('[data-vr-cart-status]'),summary=area.querySelector('[data-vr-cart-summary]');
  status.textContent='Aggiornamento del carrello…';
  try {
    const [cart]=await Promise.all([jsonRequest(`${root}cart.js`),refreshOffers()]);
    if(sequence!==cartSequence)return;reconcileCartDates(cart);
    list.replaceChildren();status.textContent=cart.item_count ? '' : 'Il tuo carrello è vuoto.';
    document.querySelectorAll('[data-vr-cart-count]').forEach(node=>node.textContent=cart.item_count);
    const cartLink=document.querySelector('#cart-icon-bubble');
    let bubble=cartLink?.querySelector('.cart-count-bubble');
    if(!bubble && cartLink && cart.item_count) {
      bubble=el('div',undefined,'cart-count-bubble');
      const number=el('span');number.setAttribute('aria-hidden','true');
      bubble.append(number,el('span',undefined,'visually-hidden'));cartLink.append(bubble);
    }
    if(bubble) {
      const number=bubble.querySelector('[aria-hidden]');if(number)number.textContent=cart.item_count;
      const label=bubble.querySelector('.visually-hidden');if(label)label.textContent=`${cart.item_count} articoli nel carrello`;
      bubble.hidden=!cart.item_count;
    }
    document.querySelectorAll('.vr-header-lists-account').forEach(link=>link.dataset.vrCartItems=String(cart.item_count));
    try{syncHeaderAccountState(read());}catch{}
    summary.hidden=!cart.item_count;area.querySelector('[data-vr-cart-total]').textContent=money(cart.total_price);
    for(const item of cart.items) {
      const {row,details,actions}=productRow({title:item.product_title},{image:item.image,href:item.url,price:item.final_line_price});
      const priceBlock=el('div',undefined,'vr-area-price-block');const price=details.querySelector('.vr-area-price');priceBlock.append(price,el('p',`Quantità: ${item.quantity}`,'vr-area-quantity'));details.append(priceBlock);
      try{
        const product=await productDetails({id:String(item.product_id),handle:item.handle});
        if(sequence!==cartSequence)return;
        const variant=product.variants.find(v=>String(v.id)===String(item.variant_id));
        appendProductControls({product,variant,href:item.url.split('?')[0],details,actions,status,inCart:true,inCartVariant:item.variant_id});
      }catch{
        actions.append(cartIndicator(addedDates()[item.variant_id]));
        const review=el('a','RIVEDI IL CARRELLO','vr-area-button vr-area-button-primary');review.href=`${root}cart`;actions.append(review);
      }
      const remove=el('button','Rimuovi dal carrello','vr-area-remove');remove.type='button';
      remove.addEventListener('click',async()=>{
        remove.disabled=true;
        try{await jsonRequest(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,quantity:0})});await renderCart();}
        catch(error){status.textContent=error.message;remove.disabled=false;}
      });details.append(remove);list.append(row);
    }
  }catch(error){if(sequence===cartSequence)status.textContent=error.message;}
}
// The storefront product button uses the same verified receipts as the dashboard.
const productOfferHosts=new WeakSet();
function setupProductOfferStates(){
  document.querySelectorAll('vr-product-offer').forEach(async host=>{
    if(productOfferHosts.has(host))return;
    productOfferHosts.add(host);
    await customElements.whenDefined('vr-product-offer');
    const button=host.opener;
    if(!button)return;
    const originalText=button.textContent.trim();
    const checkout=document.createElement('a');checkout.className='vr-product-offer-checkout';checkout.textContent='Vai all’acquisto';checkout.hidden=true;button.insertAdjacentElement('afterend',checkout);
    let current=null;
    const paint=()=>{
      const variant=String(host.variant());
      current=offerSnapshot.filter(o=>String(o.variant)===variant).sort((a,b)=>(b.createdAt||0)-(a.createdAt||0))[0];
      if(!current&&offerReceipts().some(r=>String(r.variant)===variant))current={state:'checking'};
      checkout.hidden=true;checkout.removeAttribute('href');
      const labels={pending:'OFFERTA IN ATTESA',accepted:'OFFERTA ACCETTATA',counter:'ACCETTA OFFERTA',expired:'OFFERTA SCADUTA',purchased:'GIÀ ACQUISTATO',checking:'STATO OFFERTA DA VERIFICARE',unavailable:'STATO OFFERTA DA VERIFICARE'};
      if(!current){
        delete button.dataset.vrOfferState;
        button.textContent=originalText;
        const enabled=(host.dataset.offerEligible||'').includes('|'+variant+'|');button.hidden=!enabled;button.disabled=!enabled;
        return;
      }
      button.hidden=false;button.textContent=labels[current.state]||labels.checking;
      button.dataset.vrOfferState=current.state;
      const validUrl=typeof current.purchaseUrl==='string'&&/^https:\/\/veroraro-ai-poc\.matteo-salce\.workers\.dev\/offer-purchase\/[a-f0-9]{64}$/.test(current.purchaseUrl);
      button.disabled=!(current.state==='counter'&&validUrl);
      if(current.state==='accepted'&&validUrl){checkout.href=current.purchaseUrl;checkout.hidden=false;}
    };
    const update=async(force=false)=>{if(force)offerRefreshAt=0;paint();await refreshOffers();if(host.isConnected)paint();};
    button.addEventListener('click',event=>{
      if(!current)return;
      event.preventDefault();event.stopImmediatePropagation();
      if(current.state==='counter'&&!button.disabled)location.assign(current.purchaseUrl);
    },true);
    host.addEventListener('vr-offer-availability',paint);
    host.addEventListener('vr-offer-receipt',()=>{try{syncHeaderAccountState(read());}catch{}void update(true);});
    window.addEventListener('focus',()=>{if(host.isConnected)void update(true);});
    window.addEventListener('storage',event=>{if(event.key===receiptKey&&host.isConnected)void update(true);});
    const interval=setInterval(()=>{if(!host.isConnected){clearInterval(interval);return;}if(!document.hidden&&(signedIn||offerReceipts().length))void update(true);},60000);
    void update();
  });
}
if(document.querySelector('vr-product-offer'))setupProductOfferStates();
document.addEventListener('shopify:section:load',setupProductOfferStates);
const productOfferObserver=new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches?.('vr-product-offer')||node.querySelector?.('vr-product-offer')))))setupProductOfferStates();});
productOfferObserver.observe(document.body,{childList:true,subtree:true});

let offerListSequence=0;
function offerMoney(value,currency){return new Intl.NumberFormat(document.documentElement.lang||'it-IT',{style:'currency',currency:currency||'EUR'}).format(value/100);}
function safeProductUrl(value){try{const url=new URL(value,location.origin);return url.origin===location.origin&&/\/products\/[^/]+/.test(url.pathname)?url.href:null;}catch{return null;}}
function safePurchaseUrl(value){return typeof value==='string'&&/^https:\/\/veroraro-ai-poc\.matteo-salce\.workers\.dev\/offer-purchase\/[a-f0-9]{64}$/.test(value);}
async function renderOffers(){
 const sequence=++offerListSequence,list=area.querySelector('[data-vr-offer-list]'),status=area.querySelector('[data-vr-offer-status]');
 status.textContent='Aggiornamento delle tue offerte…';
 await refreshOffers();if(sequence!==offerListSequence)return;
 list.replaceChildren();
 const offers=[...offerSnapshot].sort((a,b)=>(b.createdAt||0)-(a.createdAt||0));
 document.querySelectorAll('[data-vr-offer-count]').forEach(n=>n.textContent=offers.length||'');
 status.textContent=accountOffersUnavailable?'Non è stato possibile aggiornare le offerte del tuo account. Riprova tra poco; le proposte già inviate sono conservate.':offers.length?'':'Non risultano offerte per questo account. Le offerte inviate con un’altra email appartengono a quell’account.';
 if(!signedIn&&!offers.length)status.textContent='Accedi al tuo account VERORARO per consultare le offerte anche da altri dispositivi.';
 const labels={pending:'OFFERTA IN ATTESA',accepted:'OFFERTA ACCETTATA',counter:'ACCETTA OFFERTA',expired:'OFFERTA SCADUTA',purchased:'GIÀ ACQUISTATO',checking:'STATO DA VERIFICARE',unavailable:'OFFERTA NON PIÙ CONSULTABILE'};
 for(const offer of offers){
   const row=el('article',undefined,'vr-offer-row'),details=el('div',undefined,'vr-offer-details'),actions=el('div',undefined,'vr-offer-actions');
   const href=safeProductUrl(offer.product?.url),heading=el('h2');
   if(href){const title=el('a',offer.product.title||'La tua offerta');title.href=href;heading.append(title);}else heading.textContent='La tua offerta';
   if(offer.product?.image&&/^https:\/\//.test(offer.product.image)){const image=el('img');image.src=offer.product.image;image.alt=offer.product.title||'';image.loading='lazy';const photo=el(href?'a':'div',undefined,'vr-offer-image');if(href)photo.href=href;photo.append(image);row.append(photo);}
   details.append(heading);
   if(offer.createdAt)details.append(el('p','Inviata il '+new Date(offer.createdAt).toLocaleString(document.documentElement.lang||'it-IT'),'vr-area-note'));
   if(Number.isFinite(offer.customerAmount))details.append(el('p','La tua offerta: '+offerMoney(offer.customerAmount,offer.currency),'vr-offer-amount'));
   if(Number.isFinite(offer.agreedAmount))details.append(el('p','Proposta VERORARO: '+offerMoney(offer.agreedAmount,offer.currency),'vr-offer-amount'));
   if(offer.message)details.append(el('p',offer.message,'vr-offer-message'));
   const canBuy=['counter','accepted'].includes(offer.state)&&safePurchaseUrl(offer.purchaseUrl);
   const button=el(canBuy&&offer.state==='counter'?'a':'button',labels[offer.state]||labels.checking,'vr-area-button vr-area-offer');button.dataset.vrOfferState=offer.state||'checking';
   if(button.tagName==='A')button.href=offer.purchaseUrl;else{button.type='button';button.disabled=true;}
   actions.append(button);
   if(canBuy&&offer.state==='accepted'){const buy=el('a','Vai all’acquisto','vr-area-offer-checkout');buy.href=offer.purchaseUrl;actions.append(buy);}
   if(offer.expiresAt&&canBuy)actions.append(el('p','Riservato fino al '+new Date(offer.expiresAt).toLocaleString(document.documentElement.lang||'it-IT'),'vr-area-note'));
   row.append(details,actions);list.append(row);
 }
}

function showPanel() {
  const tab=['preferiti','carrello','ordini','offerte'].includes(location.hash.slice(1)) ? location.hash.slice(1) : 'preferiti';
  const names={preferiti:'WISHLIST',carrello:'CARRELLO',ordini:'ORDINI',offerte:'OFFERTE'};
  area.querySelector('[data-vr-area-title]').textContent=names[tab];
  area.querySelectorAll('[data-vr-tab]').forEach(link=>{if(link.dataset.vrTab===tab)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');});
  area.querySelectorAll('[data-vr-panel]').forEach(panel=>panel.hidden=panel.dataset.vrPanel!==tab);
  if(tab==='preferiti')void renderWishlist();
  if(tab==='carrello')void renderCart();
  if(tab==='offerte')void renderOffers();
}
if(area){
  window.addEventListener('focus',()=>{offerRefreshAt=0;showPanel();});
  window.addEventListener('pageshow',()=>{offerRefreshAt=0;showPanel();});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden){offerRefreshAt=0;showPanel();}});
  window.addEventListener('storage',event=>{if(event.key===receiptKey||event.key===cartDateKey){offerRefreshAt=0;showPanel();}});
  setInterval(()=>{if(!document.hidden&&(signedIn||offerReceipts().length)){offerRefreshAt=0;showPanel();}},60000);
}
if(area) { window.addEventListener('hashchange',showPanel);showPanel(); }
